import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { SelectCustom } from '../../../../common/selectCustom'
import { SCROLL_LAYOUT_ELEMENT_ID } from '../../../../layout/LayoutContainer'
import { SIDE_BAR_SCROLL_ID } from '../../../SideBarUserManagement'
import { ALL_STATUS } from '../constants'
import {
  changeFilter,
  selectFilterByKey,
  selectTransactionStatus,
} from '../store/slice'

export const TransactionStatus = ({ appendStyleContainer }) => {
  const dispatch = useDispatch()

  const transactionStatus = useSelector(selectTransactionStatus)
  const transactionStatusActive = useSelector(
    selectFilterByKey('transactionStatusActive'),
  )
  const chooseItem = (data) => {
    dispatch(changeFilter({ transactionStatusActive: data }))
  }

  const transactionStatusSelection = [
    ALL_STATUS,
    ...transactionStatus.map((item) => ({
      label: `userManagement.orderManagement.${item?.status.toUpperCase()}`,
      value: item.status,
      isI18n: true,
    })),
  ]

  return (
    <div className="dFlex alignItemsCenter" style={appendStyleContainer}>
      <Translate
        value="userManagement.orderManagement.PAYMENT_STATUS"
        className="fw600"
      />
      <SelectCustom
        className="mx1"
        activeItem={transactionStatusActive}
        data={transactionStatusSelection}
        chooseItem={chooseItem}
        isI18n
        isNoWrap
        scrollId={[SIDE_BAR_SCROLL_ID, SCROLL_LAYOUT_ELEMENT_ID]}
      />
    </div>
  )
}
